export default __webpack_public_path__ + "static/media/fan.7c532d57.svg";